import { classNames } from '../../utils/classNames';

function FormField({ id, label, hint, error, required, children, className }) {
  return (
    <div className={classNames('w-full', className)}>
      {label && (
        <label htmlFor={id} className="mb-1.5 block text-sm font-medium text-content-primary">
          {label}
          {required && <span className="ml-1 text-danger-600">*</span>}
        </label>
      )}
      {children}
      {(error || hint) && (
        <p id={`${id}-description`} className={classNames('mt-1.5 text-xs', error ? 'text-danger-600' : 'text-content-muted')}>
          {error || hint}
        </p>
      )}
    </div>
  );
}

export default FormField;
